import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useMemo } from "react";
import type { PanelDefinition } from "../../../services/admin/panels.service";

interface PanelStatusConfirmModalProps {
  panel?: PanelDefinition;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function PanelStatusConfirmModal({
  panel,
  isSubmitting,
  onClose,
  onConfirm,
}: PanelStatusConfirmModalProps) {
  const activating = useMemo(() => !panel?.isActive, [panel]);
  const action = useMemo(
    () => (activating ? "Activate" : "Deactivate"),
    [activating]
  );

  return (
    <Modal
      opened={Boolean(panel)}
      onClose={onClose}
      title={`${action} panel?`}
      centered
      closeOnClickOutside={false}
      closeOnEscape={!isSubmitting}
    >
      <Stack gap="lg">
        <Text size="sm">
          {activating
            ? `${panel?.name} will become available for new accessioning orders.`
            : `${panel?.name} will be hidden from new orders. Existing orders and versions will not change.`}
        </Text>
        <Group justify="space-between">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color={activating ? "green" : "orange"}
            loading={isSubmitting}
            onClick={onConfirm}
          >
            {action} panel
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
